import styled from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';

var header = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__header",
  componentId: "sc-1ec4oc7-0"
})(["color:", ";background-color:", ";"], function (props) {
  return props.$foregroundColor;
}, function (props) {
  return props.$backgroundColor;
});
var content = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__content",
  componentId: "sc-1ec4oc7-1"
})(["display:flex;flex-direction:row;align-items:center;height:", ";"], px2rem(80));
var left = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__left",
  componentId: "sc-1ec4oc7-2"
})(["display:flex;flex-direction:row;justify-content:flex-start;flex:1;flex-shrink:1;"]);
var center = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__center",
  componentId: "sc-1ec4oc7-3"
})(["display:flex;flex-direction:row;justify-content:center;flex:0;flex-shrink:0;color:", ";"], function (p) {
  return p.$centerComponentColor;
});
var right = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__right",
  componentId: "sc-1ec4oc7-4"
})(["display:flex;flex-direction:row;justify-content:flex-end;flex:1;flex-shrink:1;"]);

export { center, content, header, left, right };
